module.exports = __webpack_public_path__ + "img/health-insurance-info.f7f086fe.svg";